import { Card, CardBody, CardTitle } from './Card';

/**
 * The single answer to every attempt to reach content that is not yours: an
 * instance you do not belong to, another client's session, the admin area as a
 * client. `access-and-consent` requires "no hint that the content exists", so
 * this page says the same thing in every case and never mentions what was
 * asked for.
 */
export function NotFound() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md items-center px-4 py-10">
      <Card className="w-full">
        <CardTitle>Page not found</CardTitle>
        <CardBody>
          The page you are looking for does not exist, or you do not have access to it.
        </CardBody>
      </Card>
    </main>
  );
}
